import React from 'react';
import { FormProvider } from 'react-hook-form';
import { IOnFailure } from '@move-frontend/auth';
import { AuthFormSection as Section } from '../../../shared/form-layout/AuthFormSection';
import { AuthFormRow as Row } from '../../../shared/form-layout/AuthFormRow';
import { ResetPasswordFormActions } from './ResetPasswordFormActions';
import { ConfirmPassword } from '../../../shared/form-fields/ConfirmPassword';
import { Password } from '../../../shared/form-fields/Password';
import { useResetPasswordForm } from './helpers/useResetPasswordForm';
import { useTranslation } from '../../../../shared/i18n/translate/useTranslation';
import { IResetPasswordOnSuccess } from '../../domain/models/IResetPasswordOnSuccess';
import { useResetPasswordSubmit } from './helpers/useResetPasswordSubmit';

export interface IResetPasswordFormProps {
	username: string;
	code: string;
	onSuccess: IResetPasswordOnSuccess;
	onFailure: IOnFailure;
}

export const ResetPasswordForm = ({
	onSuccess,
	onFailure,
	...userData
}: IResetPasswordFormProps) => {
	const { t } = useTranslation();
	const form = useResetPasswordForm();
	const onSubmit = useResetPasswordSubmit(userData, onSuccess, onFailure);

	return (
		<FormProvider {...form}>
			<form noValidate onSubmit={form.handleSubmit(onSubmit)}>
				<Section>
					<Row columns={[2, { mobileXL: 1 }]}>
						<Password
							label={t('user_form_new_password_label')}
							validateConfirmation
							autoComplete="new-password"
						/>
						<ConfirmPassword
							label={t('user_form_confirm_new_password_label')}
						/>
					</Row>
				</Section>

				<ResetPasswordFormActions />
			</form>
		</FormProvider>
	);
};
